const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export function professionalAgendaViewOthersEnabled(metadata: unknown): boolean {
  if (!metadata || typeof metadata !== 'object' || Array.isArray(metadata)) return false;
  return (metadata as Record<string, unknown>).agenda_view_other_professionals_enabled === true;
}

export function parseAgendaViewableProfessionalIds(metadata: unknown): string[] {
  if (!metadata || typeof metadata !== 'object' || Array.isArray(metadata)) return [];
  const raw = (metadata as Record<string, unknown>).agenda_viewable_professional_ids;
  if (!Array.isArray(raw)) return [];
  const ids = raw.map((v) => String(v || '').trim()).filter((id) => UUID_RE.test(id));
  return Array.from(new Set(ids));
}

export function resolveAllowedAppointmentProfessionalIds(
  ownProfessionalId: string,
  metadata: unknown,
): string[] {
  const own = String(ownProfessionalId || '').trim();
  if (!own) return [];
  if (!professionalAgendaViewOthersEnabled(metadata)) return [own];
  const others = parseAgendaViewableProfessionalIds(metadata).filter((id) => id !== own);
  return others.length > 0 ? [own, ...others] : [own];
}

export function professionalCanViewColleagueAgendas(
  ownProfessionalId: string,
  metadata: unknown,
): boolean {
  if (!professionalAgendaViewOthersEnabled(metadata)) return false;
  const allowed = resolveAllowedAppointmentProfessionalIds(ownProfessionalId, metadata);
  return allowed.length > 1;
}

/** Usuário vinculado (de qualquer perfil) que optou por ver somente a própria agenda. */
export function professionalAgendaRestrictOwnView(metadata: unknown): boolean {
  if (!metadata || typeof metadata !== 'object' || Array.isArray(metadata)) return false;
  return (metadata as Record<string, unknown>).agenda_restrict_own_view === true;
}

export function professionalAgendaPrivateEnabled(metadata: unknown): boolean {
  if (!metadata || typeof metadata !== 'object' || Array.isArray(metadata)) return false;
  return (metadata as Record<string, unknown>).agenda_private_enabled === true;
}

export function parseAgendaPrivateViewerUserIds(metadata: unknown): string[] {
  if (!metadata || typeof metadata !== 'object' || Array.isArray(metadata)) return [];
  const raw = (metadata as Record<string, unknown>).agenda_private_viewer_user_ids;
  if (!Array.isArray(raw)) return [];
  const ids = raw.map((v) => String(v || '').trim()).filter((id) => UUID_RE.test(id));
  return Array.from(new Set(ids));
}

/** A agenda do usuário segue as regras de profissional (só a própria + colegas liberados). */
export function userAgendaFollowsProfessionalScope(
  user: { role?: string | null; professional_id?: string | null; professional?: { metadata?: unknown } | null } | null | undefined,
): boolean {
  if (!user?.professional_id) return false;
  return user.role === 'professional' || professionalAgendaRestrictOwnView(user.professional?.metadata);
}
